import React from 'react';
import cn from 'bem-cn';

import radial from '../../images/radial.svg';
import { RoutePaths } from '../../constants';

import { useGetUserScoreAndRankQuery } from '../../store';
import { useUserContext } from '../../contexts';
import { ScreenSize, useGetScreenSize } from '../../hooks';

import { AvatarWithRating, Stack, Link, ImageWithFadeIn, ScoreBadge, Icon } from '../UI';

import './ProfileCard.scss';

const b = cn('profile-card');

export const ProfileCard: React.FC = () => {
    const { user } = useUserContext();
    const { data, isError, isLoading } = useGetUserScoreAndRankQuery({});

    const screenSize = useGetScreenSize();
    const isMobile = screenSize === ScreenSize.Mobile;

    if (isMobile) {
        return (
            <Link to={RoutePaths.ProfilePrompts}>
                <Stack className={b()} alignItems="center" spacing={10} direction="row">
                    <div className={b('background')}>
                        <ImageWithFadeIn src={radial} alt="" />
                    </div>
                    <AvatarWithRating
                        avatarSrc={user.avatarSrc}
                        size="small"
                        hideScore
                        rank={data?.rank !== undefined ? data.rank + 1 : undefined}
                    />
                    <Stack spacing={2}>
                        <span className={b('name')}>
                            {user.firstName} {user.lastName?.at(0)}.
                        </span>
                        <Stack spacing={6} direction="row" alignItems="center" className={b('place')}>
                            <span>Вы в рейтинге:</span>
                            <Icon name="trophy" size={20} fillColor="rgba(0, 0, 0, 0.6)" className="trophy" />
                            <span>{data?.rank !== undefined ? data.rank + 1 : '-'}</span>
                        </Stack>
                    </Stack>
                    {!(isError || data?.is_user_exists === false) && (
                        <ScoreBadge
                            size="medium"
                            score={data?.score}
                            isLoading={isLoading}
                            className={b('score-badge')}
                        />
                    )}
                </Stack>
            </Link>
        );
    }

    return (
        <Link to={RoutePaths.ProfilePrompts}>
            <Stack className={b()} justifyContent="center" alignItems="center" spacing={8}>
                <div className={b('background')}>
                    <ImageWithFadeIn src={radial} alt="" />
                </div>
                <AvatarWithRating
                    size="medium"
                    avatarSrc={user.avatarSrc}
                    score={data?.score}
                    isScoreLoading={isLoading}
                    scoreError={isError || data?.is_user_exists === false}
                    rank={data?.rank !== undefined ? data.rank + 1 : undefined}
                />
                <span className={b('name')}>
                    {user.firstName} {user.lastName?.at(0)}.
                </span>
                <Stack spacing={6} direction="row" alignItems="center" justifyContent="center" className={b('place')}>
                    <Icon name="trophy" size={20} fillColor="rgba(0, 0, 0, 0.6)" className="trophy" />
                    <span>{data?.rank !== undefined ? data.rank + 1 : '-'}</span>
                </Stack>
            </Stack>
        </Link>
    );
};
